<template>
  <div class="r-shipment">
    <div class="r-shipment-header common-flex common-justify-between">
      <div class="code">No.{{config.code}}<Poptip placement="right" width="400"></Poptip></div>
      <div class="date">{{$t('shipment.deliveryDate')}}: {{config.shipdate||'---- / -- / --'}}</div>
    </div>
    <div class="shipment-details common-flex common-justify-between">
      <div class="logistics common-flex">
        <div class="logistics-img">
          <!-- <Icon type="md-plane" style="width:69px;height:69px;font-size: 69px;" /> -->
          <!-- <img :src="config.expressUrl" alt=""> -->
          <img src="../assets/images/wwl.png" alt="">
        </div>
        <div class="common-flex common-direction-column common-justify-around">
          <div class="way-bill">{{ $t("shipment.waybillNo") }}:{{config.waybillNo}}</div>
          <div class="way-msg common-flex" v-if="config.address">
            <span >{{config.address.contact}}</span> | <span>{{config.address.phone}}</span>  |
            <span>{{config.address.addressInfo}}</span>
          </div>
          <div class="way-options">
            <span @click="details" class="details common-hover"
              >{{ $t("shipment.detail") }}</span
            >
            <span class="delete common-hover" v-if="config.status==10371||config.status==10372" @click="delShip"> | {{ $t("shipment.delete") }}</span>
          </div>
        </div>
      </div>
      <div class="order">
        <div class="include-order">{{ $t("shipment.includeOrder") }}</div>
        <div v-if="index<2" v-for="(item,index) in config.orderList" :key="index">{{item.orderCode}}<span v-if="item.custOrderCode">: {{item.custOrderCode}}</span> </div>
        <!-- <div v-if="config.remark">Remark:{{ config.remark }}</div> -->
        <!-- <div>Order 2: ACE210200012POLL-22</div> -->
      </div>
      <div v-if="config.status==10033" class="status common-flex common-align-center common-flex-end">
          <span></span>
          {{config.statusName}}
      </div>
      <div v-else-if="config.status==10371" style="color:#0A4DCC" class="status common-flex common-align-center common-flex-end">
          <span style="backgroundColor:#0A4DCC;"></span>
          {{config.statusName}}
      </div>
      <div v-else style="color:#0C750E" class="status common-flex common-align-center common-flex-end">
          <span style="backgroundColor:#0C750E;"></span>
          {{config.statusName}}
      </div>
    </div>
    <Modal
        v-model="modal"
        title="Add Notes"
        @on-ok="ok"
        @on-cancel="cancel">
        <Input v-model="remark"></Input>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "r-shipment",
  data() {
    return {
      modal:false
    };
  },
  props:{
    config:Object
  },
  methods:{
    ...mapActions([
      'shippingRemarkAction'
    ]),
    //   跳转详情
      details(){
        this.$router.push({
          path:'./shipmentDetails',
           query:{
            id:this.config.id
          }
        })
      },
      ok(){
        this.shippingRemarkAction({
          remark:this.remark,
          // id:this.config.express
          id:this.config.id
        }).then(res=>{
          this.config.remark = this.remark
        })
      },
      cancel(){

      },
      // 修改备注
      changeRemark(e){
        this.modal = true
        this.remark = this.config.remark
      },
      // 删除
      delShip(){
         this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.$emit('delShip',this.config)
        },
      });
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-shipment {
  width: 1360px;
  margin: 20px auto;
  border: 1px solid #ecedef;
  .r-shipment-header {
    height: 50px;
    background: #f8f8f8;
    padding: 15px 20px;
    .include-order {
      opacity: 0.4;
      font-size: 12px;
      font-family: Roboto, Roboto-Bold,serif;
      font-weight: 700;
      text-decoration: underline;
      text-align: left;
      color: #081938;
      line-height: 14px;
      letter-spacing: 0px;
    }
  }
  .code {
    font-size: 14px;
    font-family: Roboto, Roboto-BoldCondensed;
    font-weight: BoldCondensed;
    text-align: left;
    color: #081938;
    line-height: 16px;
    letter-spacing: 1px;
  }
  .time {
    opacity: 0.7;
    font-size: 14px;
    font-family: Roboto, Roboto-Condensed;
    font-weight: Condensed;
    text-align: right;
    color: #081938;
    line-height: 16px;
    letter-spacing: 1px;
  }
  .shipment-details {
    padding: 20px;
    background: #fff;
    .logistics {
      width: 800px;
      .logistics-img {
        width: 69px;
        // height: 69px;
        border-radius: 4px;
        // background: #f8c604;
        margin-right: 21px;
        line-height: 69px;
        img{
          width: 69px;
          margin-top: 15px;
        // height: 69px;
        }
      }
      .way-bill {
        font-size: 16px;
        font-family: Roboto, Roboto-Medium;
        font-weight: 500;
        text-align: left;
        color: #081938;
        line-height: 19px;
      }
      .way-msg {
        opacity: 0.7;
        font-size: 12px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 14px;
        span{
          margin: 0 5px;
        }
      }
      .way-options {
        font-size: 12px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-decoration: underline;
        text-align: left;
        color: #0a4dcc;
        line-height: 14px;
      }
    }
    .order {
      width: 270px;
      text-align: left;
      font-size: 12px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 14px;
      >div{
          margin-bottom:10px
      }
      .include-order {
        opacity: 0.4;
        font-size: 12px;
        font-family: Roboto, Roboto-Bold;
        font-weight: 700;
        text-decoration: underline;
        text-align: left;
        color: #081938;
        line-height: 14px;
        letter-spacing: 0px;
      }
    }
    .status {
      width: 270px;
      text-align: right;
      color: #D87508;
      span{
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #D87508;
          margin-right: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-shipment.vue